'use strict';

// deep copy

export { default as extend } from 'extend';

/**
 * 生成GUID
 */
export function guid() {
    return '{}{}-{}-{}-{}-{}{}{}'.replace(/{\}/g, function s4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    });
}

/**
 * 清除字符串两端的空格
 * @param {String} str
 */
export function trim(str: string) {
    return !String.prototype.trim ? str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '') : str.trim();
}

/**
 * 所有单词首字母大写
 * @param {String} str
 */
export function ucwords(str: string) {
    return str.toLowerCase().replace(/\b(\w)|\s(\w)/g, function($1) {
        return $1.toUpperCase();
    });
}

/**
 * 字符串首字母大写
 * Only string first char to uppercase
 *
 * @param   {String}    str            string
 * @returns {String}                   string
 */
export function firstUpperCase(str: string) {
    return str.toLowerCase().replace(/\b(\w)/, function($1) {
        return $1.toUpperCase();
    });
}

// load css
export function loadCss(fileName: string, into?: any) {
    return new Promise((resolve, reject) => {
        into = into || 'head';

        const css: any = document.createElement('link');
        css.type = 'text/css';
        css.rel = 'stylesheet';
        css.onload = css.onreadystatechange = resolve;

        css.href = fileName + '.css';

        if (into === 'head') {
            document.getElementsByTagName('head')[0].appendChild(css);
        } else {
            document.body.appendChild(css);
        }
    });
}

// load script
export function loadScript(fileName: string, into?: any) {
    return new Promise((resolve, reject) => {
        into = into || 'head';

        const script = document.createElement('script');
        script.id = fileName.replace(/[./]+/g, '-');
        script.type = 'text/javascript';
        script.src = fileName + '.js';

        script.onload = function() {
            this.onload = this.onerror = null;
            resolve();
        };

        script.onerror = function() {
            this.onload = this.onerror = null;
            reject();
        };

        // if (editormd.isIE8) {
        //     script.onreadystatechange = function () {
        //         if (script.readyState) {
        //             if (script.readyState === "loaded" || script.readyState === "complete") {
        //                 script.onreadystatechange = null;
        //                 editormd.loadFiles.js.push(fileName);
        //                 callback();
        //             }
        //         }
        //     };
        // }
        // else {
        //     script.onload = function () {
        //         editormd.loadFiles.js.push(fileName);
        //         callback();
        //     };
        // }

        if (into === 'head') {
            document.getElementsByTagName('head')[0].appendChild(script);
        } else {
            document.body.appendChild(script);
        }
    });
}

export function addClass(nodes: any, ...classes: any) {
    if (!classes.length || !nodes.length) return;
    const support = !!nodes[0].classList;

    for (let i = 0; i < nodes.length; i++) {
        if (support) {
            nodes[i].classList.add(...classes);
        } else {
            nodes[i].className += ' ' + classes.join(' ');
        }
    }
}

export function hasClass(node: any, clss: any) {
    const support = !!node.classList;
    if (support) {
        return node.classList.contains(clss);
    } else {
        return node.className.split(/\s+/).indexOf(clss) > -1;
    }
}

export function mouseOrTouch(mouseEventType: any, touchEventType: any) {
    mouseEventType = mouseEventType || 'click';
    touchEventType = touchEventType || 'touchend';

    let eventType = mouseEventType;

    try {
        document.createEvent('TouchEvent');
        eventType = touchEventType;
    } catch (e) {
        console.log(e);
    }

    return eventType;
}

export function dateFormat(format?: string) {
    format = format || '';

    const addZero = function(d: string | number) {
        return d < 10 ? '0' + d : d;
    };

    const date = new Date();
    const year = date.getFullYear();
    const year2 = year.toString().slice(2, 4);
    const month = addZero(date.getMonth() + 1);
    const day = addZero(date.getDate());
    const weekDay = date.getDay();
    const hour = addZero(date.getHours());
    const min = addZero(date.getMinutes());
    const second = addZero(date.getSeconds());
    const ms = addZero(date.getMilliseconds());
    let datefmt: string | number;

    const ymd = year2 + '-' + month + '-' + day;
    const fymd = year + '-' + month + '-' + day;
    const hms = hour + ':' + min + ':' + second;

    const cnWeekDays = ['日', '一', '二', '三', '四', '五', '六'];
    const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    switch (format) {
        case 'UNIX Time':
            datefmt = date.getTime();
            break;

        case 'UTC':
            datefmt = date.toUTCString();
            break;

        case 'yy':
            datefmt = year2;
            break;

        case 'year':
        case 'yyyy':
            datefmt = year;
            break;

        case 'month':
        case 'mm':
            datefmt = month;
            break;

        case 'cn-week-day':
        case 'cn-wd':
            datefmt = '星期' + cnWeekDays[weekDay];
            break;

        case 'week-day':
        case 'wd':
            datefmt = weekDays[weekDay];
            break;

        case 'day':
        case 'dd':
            datefmt = day;
            break;

        case 'hour':
        case 'hh':
            datefmt = hour;
            break;

        case 'min':
        case 'ii':
            datefmt = min;
            break;

        case 'second':
        case 'ss':
            datefmt = second;
            break;

        case 'ms':
            datefmt = ms;
            break;

        case 'yy-mm-dd':
            datefmt = ymd;
            break;

        case 'yyyy-mm-dd':
            datefmt = fymd;
            break;

        case 'yyyy-mm-dd h:i:s ms':
        case 'full + ms':
            datefmt = fymd + ' ' + hms + ' ' + ms;
            break;

        case 'full':
        case 'yyyy-mm-dd h:i:s':
        default:
            datefmt = fymd + ' ' + hms;
            break;
    }

    return datefmt;
}

// 节流器
export function throttle(func: any, wait: any, options?: any) {
    /* options的默认值
     *  表示首次调用返回值方法时，会马上调用func；否则仅会记录当前时刻，当第二次调用的时间间隔超过wait时，才调用func。
     *  options.leading = true;
     * 表示当调用方法时，未到达wait指定的时间间隔，则启动计时器延迟调用func函数，若后续在既未达到wait指定的时间间隔和func函数又未被调用的情况下调用返回值方法，则被调用请求将被丢弃。
     *  options.trailing = true;
     * 注意：当options.trailing = false时，效果与上面的简单实现效果相同
     */
    let context: any, args: any, result: any;
    let timeout: any = null;
    let previous = 0;
    if (!options) options = {};
    const later = function() {
        previous = options.leading === false ? 0 : new Date().getTime();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    return function(...restArgs) {
        const now = new Date().getTime();
        if (!previous && options.leading === false) previous = now;
        // 计算剩余时间
        const remaining = wait - (now - previous);
        context = this;
        args = restArgs;
        // 当到达wait指定的时间间隔，则调用func函数
        // 精彩之处：按理来说remaining <= 0已经足够证明已经到达wait的时间间隔，但这里还考虑到假如客户端修改了系统时间则马上执行func函数。
        if (remaining <= 0 || remaining > wait) {
            // 由于setTimeout存在最小时间精度问题，因此会存在到达wait的时间间隔，但之前设置的setTimeout操作还没被执行，因此为保险起见，这里先清理setTimeout操作
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) {
            // options.trailing=true时，延时执行func函数
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
}

export const createModalEvent = (args = {}) => {
    return {
        id: guid(),
        timestamp: Date.now(),
        canceled: false,
        ...args,
    };
};
